import { smoothScroll } from "./helpers"

/**
 * Mobile menu
 */
const btnBurger = document.querySelector('.navigation-header__menu-burger')
const btnBurgerIcon = document.querySelector('.navigation-header__menu-burger i[class^="icon"]')
const menu = document.querySelector('.navigation-header')
const menuItems = document.querySelectorAll('.navigation-header__menu li a')

let burgerClicked = false

const toggleMenu = () => {
  burgerClicked = !burgerClicked

  if (burgerClicked) {
    btnBurger.setAttribute(
      'aria-expanded',
      btnBurger.classList.contains('active')
    )

    btnBurgerIcon.classList.remove('icon-menu');
    btnBurgerIcon.classList.add('icon-cancel');

    menu.classList.add('active')
    btnBurger.classList.add('active')
  } else {
    menu.classList.remove('active')
    
    btnBurger.classList.remove('active')
    btnBurgerIcon.classList.remove('icon-cancel');
    btnBurgerIcon.classList.add('icon-menu');
  }
}

btnBurger.addEventListener('click', toggleMenu)

menuItems.forEach((item) => {
  item.addEventListener('click', toggleMenu)
})

const links = document.querySelectorAll('a[href^="#"]')

links.forEach((link, index) => {
  link.addEventListener('click', (e) => {
    const homeUrl = window.enigmatyka_global.home_url

    if (
      (homeUrl + '/').replace(window.location.origin, '') ===
      window.location.pathname
    ) {
      e.preventDefault()
      document
        .querySelectorAll(
          '.navigation-header.active, .navigation-header__menu-burger.active'
        )
        .forEach((element) => {
          element.classList.remove('active')
        })
      smoothScroll(e.target.getAttribute('href'), 200)
    } else {
      window.location.replace(homeUrl + '/' + e.target.hash)
    }
  })
})
